import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, ModalHeader } from 'reactstrap';
import { SelectInput } from '../selectInputComponent';
import { APIClient } from '../../helpers/api_helper';
import { createData } from '../../utils/createData';

export const ModalReasonChangeStatus = ({
  toogle,
  handleSubmit,
  isOpen,
  status,
}) => {
  const [changeReason, setChangeReason] = useState(null);
  const [statusSelected, setStatusSelected] = useState(null);
  const [optionStatus, setOptionsStatus] = useState([]);
  const [isError, setIsError] = useState(false);
  const api = new APIClient();

  const handleChangeStatus = () => {
    if (changeReason && statusSelected) {
      handleSubmit(changeReason, statusSelected);
      handleCleanupState();
    } else {
      setIsError(true);
    }
  };

  const handleCleanupState = () => {
    setChangeReason('');
    setStatusSelected(null);
    setIsError(false);
  };

  const getStatus = async () => {
    await api
      .get(`/proposal/get-status?without=1,3,${status}`)
      .then((response) => {
        setOptionsStatus(createData(response || []));
      });
  };

  useEffect(() => {
    if (status) {
      getStatus();
    }
  }, [status]);

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={isOpen}
      toggle={() => {
        toogle();
      }}
      modalClassName="fadeInLeft"
      centered
      autoFocus={false}
    >
      <ModalHeader>Alterar Status da proposta</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            handleChangeStatus(e);
          }}
        >
          <div className="mb-3">
            <label htmlFor="type-name" className="col-form-label">
              Selecione a nova situação da proposta
            </label>
            <SelectInput
              className="form-control"
              options={optionStatus}
              onChange={(e) => setStatusSelected(e)}
              value={statusSelected}
              invalid={isError && !statusSelected}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="type-name" className="col-form-label">
              Digite o motivo da mudança
            </label>
            <Input
              autoFocus={true}
              type="textarea"
              className="form-control"
              id="typeName"
              onChange={(e) => setChangeReason(e.target.value)}
              value={changeReason}
              invalid={isError && !changeReason}
            />
          </div>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                toogle();
                handleCleanupState();
              }}
            >
              {' '}
              Voltar{' '}
            </button>
            <Button
              className="btn btn-warning"
              type="button"
              onClick={handleChangeStatus}
            >
              {' '}
              Alterar{' '}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
